












































import {
    Component,
    Vue,
    Emit,
    Prop,
    Provide,
    Watch
} from "vue-property-decorator";
import { State, Getter, namespace } from "vuex-class";
import { IPortalUser } from "../../../models/interfaces/authentication/portal-user.model.interface";
import UserRoleDropdown from "@/components/user/UserRoleDropdown.vue";
import AuthoriseUserButton from "@/components/user/buttons/AuthoriseUserButton.vue";
import BlockUserButton from "@/components/user/buttons/BlockUserButton.vue";
import RevenueAccessButton from "@/components/user/buttons/RevenueAccessButton.vue";
import Loader from "@/components/Loader.vue";

const UserModule = namespace("userModule");

@Component({
    components: {
        UserRoleDropdown,
        AuthoriseUserButton,
        BlockUserButton,
        RevenueAccessButton,
        Loader
    }
})
export default class UserTable extends Vue {
    @UserModule.Getter public userId: number;
    @UserModule.Getter public authorise: boolean;

    @Prop() public user: IPortalUser | null;

    @Prop({ default: "Table" })
    public caption: string;

    @Provide() public items: IPortalUser[] = [];

    @Provide() public isLoggedInUser: boolean = false;

    @Provide()
    public columns = [
        { key: "fullName" },
        { key: "emailAddress" },
        { key: "company" },
        { key: "registrationDate" },
        { key: "lastLoginDate" },
        { key: "authorised" },
        { key: "blocked" },
        { key: "revenueAccess" },
        { key: "role", label: "Role" }
    ];

    private loading: boolean = true;

    get getUser() {
        return this.user;
    }

    get isUserAuthorised(): boolean {
        if (this.getUser) {
            return this.getUser.authorised;
        }

        return false;
    }

    get isUserValidated(): boolean {
        if (this.getUser) {
            return this.getUser.emailValidated;
        }

        return false;
    }

    public checkLoggedInUser(model: IPortalUser | null) {
        if (model) {
            this.isLoggedInUser = model.id === this.userId;
        } else {
            this.isLoggedInUser = false;
        }
    }

    @Watch("getUser")
    public onUserChanged(val: IPortalUser | null, oldVal: IPortalUser | null) {
        if (val) {
            this.items = [val];
            this.checkLoggedInUser(val);
            this.loading = false;
        }
    }
}
